import { fetchTariffHistory } from '../../../services/api/tariff';
import { naturalCompare } from '../../../helpers';

function getRequestValue(history, key) {
    switch (key) {
        case 'total':
            return history.ordersCount * history.cost;
        default:
            return history[key];
    }
}

export const tariffHistory = {
    namespaced: true,
    state: {
        sort: {
            column: 'title',
            order: 'desc',
        },
        history: [],
    },
    mutations: {
        save(state, data) {
            state.history = data;
        },
        sorting(state, sort) {
            state.sort = sort;
        }
    },
    actions: {
        fetchHistory({ commit, dispatch }) {
            return fetchTariffHistory()
                .then((res) => {
                    commit('save', res.data);
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        sorting({ commit }, sort) {
            commit('sorting', sort);
        }
    },
    getters: {
        history({ history }) {
            return history;
        },
        sort({ sort }) {
            return sort;
        },
        sortedHistory({ sort, history }) {
            const sorted = history.sort((a, b) => {
                return naturalCompare(
                    getRequestValue(a, sort.column),
                    getRequestValue(b, sort.column));
            });

            return sort.order === 'asc'
                ? sorted
                : sorted.reverse();
        }
    },
};



// WEBPACK FOOTER //
// ./src/modules/home/tariffHistory/store.js